import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import store from 'store';
import Logout from './logout';
import AuthRestore from './restore';
import AuthMember from './member';
import AuthRedirect from './redirect';
import { FFmpegProvider } from 'contexts/FFmpegContext';
import useLocation from 'app/hooks/location';
import useHistory from 'app/hooks/history';
import { patch } from 'utils/api';

const Auth = ({ children }) => {
  const { pathname, search } = useLocation();

  // allows devs to set token in env file
  if (process.env.REACT_APP_USER_AUTH_TOKEN) {
    store.set('auth_token', process.env.REACT_APP_USER_AUTH_TOKEN);
  }
  useEffect(() => {
    if (process.env.REACT_APP_BUILD_TARGET === 'production')
      window.Beacon('init', 'd7a4de69-436f-48cd-a4c2-deeb4be0bc7a')
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname, search])

  return (
    <FFmpegProvider >
      <AuthRestore>
        <AuthMember>
          <AuthRedirect>
            <Logout>{children}</Logout>
          </AuthRedirect>
        </AuthMember>
      </AuthRestore>
    </FFmpegProvider>
  );
};
Auth.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth;
